// extracted by mini-css-extract-plugin
export default {"wrapClassName":"JexQX24dQmkvrNFcvqRg","default":"LUo5eqIbtr5uWvHbvVzA","defaultSophie":"wuxPpUrHW6dfTgfe2HUy","center":"gbwYxL3FIa9c6OUJgb2g","confirm":"hqeCY0dkO0ClaLXNKCQj"};